import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { UsersService } from "../../../../services/users.service";
import { GeneralItemDetailDialogComponent } from "../../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Logistic } from "../../../../model/logistic";
import { EMPTY, Observable, of } from "rxjs";
import { DialogsService } from "../../../../services/dialogs.service";
import { SnackService } from "../../../../services/snack.service";
import { switchMap, tap } from "rxjs/operators";
import { Sort } from "@angular/material/sort";
import { CreateLogisticDialogComponent } from "../create-logistic-dialog/create-logistic-dialog.component";
import { Constants } from "../../../../utils/constants";
import { merge } from "lodash-es";

@Component({
  selector: 'aw-list-logistics',
  templateUrl: './list-logistics.component.html',
  styleUrls: ['./list-logistics.component.scss']
})
export class ListLogisticsComponent implements OnInit {

  public displayedColumns = [

    'firstName',
    'lastName',
    'email',
    'phone',
    'enabled',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorLogistics') paginatorUsers!: MatPaginator;
  dataSource!: MatTableDataSource<Logistic>;
  private allLogistics$!: Observable<Logistic[]>;
  roles = Constants.roles;

  constructor(
    public dialog: MatDialog,
    private usersService: UsersService,
    private dialogsService: DialogsService,
    private snackService: SnackService
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.allLogistics$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => this.usersService.getAllLogistics()),
          tap(x => {
            this.dataSource = new MatTableDataSource<Logistic>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allLogistics$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortUsers(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      if (event.active === 'id') {
        if (event.direction === 'asc') {
          return ('' + b.id).localeCompare('' + a.id);
        } else {
          return ('' + a.id).localeCompare('' + b.id);
        }
      }

      if (event.active === 'firstName') {
        if (event.direction === 'asc') {
          return ('' + b.firstName).localeCompare('' + a.firstName);
        } else {
          return ('' + a.firstName).localeCompare('' + b.firstName);
        }
      }

      if (event.active === 'lastName') {
        if (event.direction === 'asc') {
          return ('' + b.lastName).localeCompare('' + a.lastName);
        } else {
          return ('' + a.lastName).localeCompare('' + b.lastName);
        }
      }

      if (event.active === 'email') {
        if (event.direction === 'asc') {
          return ('' + b.email).localeCompare('' + a.email);
        } else {
          return ('' + a.email).localeCompare('' + b.email);
        }
      }

      if (event.active === 'phone') {
        if (event.direction === 'asc') {
          return ('' + b.phone).localeCompare('' + a.phone);
        } else {
          return ('' + a.phone).localeCompare('' + b.phone);
        }
      }

      return -1;


    }
    );
  }

  details(user: Logistic): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: user });
  }

  createUser(): void {
    this.disabled = true;
    this.dialog
      .open(CreateLogisticDialogComponent, { data: new Logistic() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allLogistics$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editUser(user: Logistic): void {
    this.disabled = false;
    this.dialog
      .open(CreateLogisticDialogComponent, { data: user })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allLogistics$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteUser(logistic: Logistic): void {
    this.disabled = true;
    const id = logistic.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete logistic', `Are you sure you want to delete the logistic "${logistic.firstName} ${logistic.lastName}"?`)
      .pipe(
        switchMap((value) => value ?
          this.usersService.deleteLogistic(<number>logistic.id) :
          EMPTY),
        switchMap(() => this.allLogistics$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Logistic deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.snackService.success('Logistic deleted!');
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  changeLogisticHabilitation(logistic: Logistic): void {
    this.disabled = true;
    const editedLogistic = merge(new Logistic(), logistic);
    editedLogistic.enabled = !logistic.enabled;
    const keyword = editedLogistic.enabled ? 'enable' : 'disable';
    this.dialogsService
      .confirm(`${keyword.toUpperCase()} logistic`, `Are you sure you want to ${keyword} the logistic "${logistic.firstName} ${logistic.lastName}"?`)
      .pipe(
        switchMap((value) => value ? this.usersService.updateLogistic(editedLogistic) : EMPTY),
        switchMap(() => this.allLogistics$)
      )
      .subscribe(() => {
        this.snackService.success(`Logistic ${keyword}d!`);
        this.disabled = false;
      },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        });
  }
}
